module.exports = __webpack_public_path__ + "static/media/about_us_our_social_acts.a388d26e.png";